import { HttpService } from "../shared/http.service";

export class FooterService {
  $http = new HttpService();

  constructor() { }

  findFooter() {
    return this.$http.get("api/footer?populate=*");
  }

  findMidiaSocial() {
    return this.$http.get("api/midia-socials?filters[ativo][$eq]=true");
  }
}